<template>
  <div class="p_zpxq">
    <p class="zpNav"><span @click="()=>this.$router.push('/')">Home</span> > <span @click="()=>this.$router.back()">Exhibits</span> > Products Detail</p>
    <div class="zpxqHeader">
      <div class="zpmz">
        <h2>{{list.proname_en}}</h2>
        
      </div>
    </div>
    <div class="zpxqContent">
      <div class="contentL">
        <div class="conImg">
          <el-image 
            :lazy="true"
            fit="contain"
            :src="list.img_url?list.img_url:'http://e.cippe.com.cn//public/images/logo_1.png'" 
            :preview-src-list="[list.img_url]">
          </el-image>
        </div>
      </div>
      <div class="contentR">
        <p>
          <span class="p1">Product Categories:</span>
          <span class="p2">{{list.class_name_en}}</span>
        </p>
        <p>
          <span class="p1">Exhibitor Name:</span>
          <span class="p2 chaolianjie" @click="()=>{this.$router.push('/exhibitor/details/'+list.fk_oeid+'/'+list.ocid)}">{{list.corpname_en}}</span>
        </p>
        <p>
          <span class="p1">Exhibit Description:</span>
          <span class="p2">{{list.prodetails_en}}</span>
        </p>
        <p>
          <span class="p1">Add:</span>
          <span class="p2">{{list.address_en}}</span>
        </p>
        <p>
          <span class="p1">Tel:</span>
          <span class="p2">{{list.phone}}</span>
        </p>
        <p>
          <span class="p1">Specification/model:</span>
          <span class="p2">{{list.pro_specification_type?list.pro_specification_type:'Negotiate'}}</span>
        </p>
        <p>
          <span class="p1">Product Price:</span>
          <span class="p2">{{list.pro_price?list.pro_price:'Negotiate'}}</span>
        </p>

        <div class="detailBtn">
          <button :class="collect==2?'collectActive':''" @click="isCollect(list.id)"><i class="iconFont icon-shoucang"></i>{{collect==2?"My Favorites":"Favorites"}}</button>
          <button @click="centerDialogVisible = true"><i class="iconFont icon-liuyan"></i>enquiry</button>
          <button :class="meet?'':'collectActive'" @click="isCorpApp(list.ocid)"><i class="iconFont icon-dianhua1"></i>{{meet?"Contact":"Contacted"}}</button>
        </div>
        <button class="intentionBtn" @click="reqIntentiondata">My orders</button>
      </div>
    </div>
    <div class="exchange">
      <div class="exchangeItem">
        <div class="exchangeTop">
          <span>Online Favorites</span>
          <img :src="hrefurl+'/public/icon/enshrine.png'" alt=""/>
        </div>
        <div class="exchangeBtn">
          <button :class="collect==2?'btnACtive':''" @click="isCollect(list.id)">
            <img :src="collect==2?hrefurl+'/public/icon/like_1.png':hrefurl+'/public/icon/enshrine_2.png'" alt=""/>
            {{collect==2?"My Favorites":"Favorites"}}
          </button>
        </div>
      </div>
      <div class="exchangeItem">
        <div class="exchangeTop">
          <span>Contact Immediately</span>
          <img :src="hrefurl+'/public/icon/negotiate.png'" alt=""/>
        </div>
        <div class="exchangeBtn1">
          <button @click="centerDialogVisible = true" @mouseover="inquiry=false" @mouseout="inquiry=false">
            <img :src="inquiry?hrefurl+'/public/icon/negotiate_2.png':hrefurl+'/public/icon/negotiate_1.png'" alt=""/>
            Enquiry
          </button>
        </div>
      </div>
      <div class="exchangeItem">
        <div class="exchangeTop">
          <span>Appointment for Negotiation</span>
          <img :src="hrefurl+'/public/icon/pack.png'" alt=""/>
        </div>
        <div class="exchangeBtn">
          <button  :class="meet?'':'btnACtive'" @click="isCorpApp(list.ocid)" @mouseover="inquiry2=true" @mouseout="inquiry2=false">
            <img :src="meet==0||inquiry2?hrefurl+'/public/icon/pack_1.png':hrefurl+'/public/icon/pack_2.png'" alt=""/>
            {{meet?"Contact":"Contacted"}}
          </button>
        </div>
      </div>
    </div>
    <div class="zplb">
      <Product :xgcp="xgcp" @update="xgxx"/>
    </div>
    <!-- 询盘弹窗 start -->
    <el-dialog title="Enquiry" :visible.sync="centerDialogVisible" width="660px" :before-close="handleClose" center>
      <div class="textea">
        <el-input type="textarea" class="popUp" show-word-limit  maxlength="200" placeholder="Input Message" v-model="textarea"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false;textarea=''">Cancel</el-button>
        <el-button type="primary" @click="reqAddCon">Send</el-button>
      </span>
    </el-dialog>
    <!-- 询盘弹窗 end -->
    <!-- 约见弹窗 start -->
    <el-dialog class="yuyue" title="Make an Appointment" :visible.sync="dialogFormVisible" :before-close="resetForm" width="650px" top="3vh" center>
      <el-form ref="preAboutData" :model="preAboutData" :rules="rules" size="mini">
        <el-form-item label="Appointment Date" prop="date">
          <el-date-picker type="date" placeholder="Select Date" v-model="preAboutData.date" :picker-options='pickerOptions' style="width: 100%;"></el-date-picker>
        </el-form-item>
        <el-form-item label="Leave a Message" prop="connet">
          <el-input type="textarea" maxlength="150" show-word-limit placeholder="Input Your Message" v-model="preAboutData.connet"></el-input>
        </el-form-item>
        <el-form-item size="large" style="text-align: center">
          <el-button type="primary" @click="submitForm('preAboutData')">Request A Meeting</el-button>
          <el-button @click="resetForm">Cancel</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 约见弹窗 end -->
    <!-- 意向订单 satrt -->
    <el-dialog class="yuyue intention" title="My orders" :visible.sync="intention" :before-close="intentionResetForm" width="650px" top="3vh" center>
      <p class="intention_row">
        <span class="span1">Company Name</span>
        <span class="span2">{{user.corpname}}</span>
      </p>
      <p class="intention_row">
        <span class="span1">Full Name</span>
        <span class="span2">{{user.name?user.name:user.nickname}}</span>
      </p>
      <p class="intention_row">
        <span class="span1">Mobile</span>
        <span class="span2">{{user.mobile}}</span>
      </p>
      <p class="intention_row">
        <span class="span1">Email</span>
        <span class="span2">{{user.email}}</span>
      </p>
      <p class="intention_row">
        <span class="span1">Product Name</span>
        <span class="span2">{{list.corpname_cn}}</span>
      </p>
      <p class="intention_row">
        <span class="span1">Specification/model</span>
        <span class="span2">{{list.pro_specification_type?list.pro_specification_type:'Negotiate'}}</span>
      </p>
      <p class="intention_row">
        <span class="span1">Unit price</span>
        <span class="span2">{{list.pro_price?list.pro_price:'Negotiate'}}</span>
      </p>
      <el-form ref="intentionData" :model="intentionData" :rules="intentionRules" label-width="150px" size="mini">
        <el-form-item label="Quantity" prop="amount">
          <el-input v-model.number="intentionData.amount"></el-input>
        </el-form-item>
        <el-form-item label="Delivery Address" prop="address">
          <el-input show-word-limit placeholder="Delivery Address" v-model="intentionData.address"></el-input>
        </el-form-item>
        <el-form-item size="large" style="text-align: center;margin-left:-100px">
          <el-button style="width:100%" type="primary" @click="intentionSubmitForm('intentionData')">Confirm and Submit</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 意向订单 end -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import Product from "../../zsxq/pc/product";
import {reqDetails, reqExhibitList, reqProColl, reqProCollDo, reqCorpAppDo, reqAddNote, reqListjsonOrderAdd} from "../../../api"
export default {
  components:{
    Product,
  },
  data(){
    var checkNumber = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Quantity is a required field'));
      }
      setTimeout(() => {
        if (!Number.isInteger(value)) {
          callback(new Error('Please input quantity'));
        } else {
          if (value < 1) {
            callback(new Error('Quantity needs to greater than 1'));
          } else {
            callback();
          }
        }
      }, 1000);
    };
    return{
      imgList:["https://picsum.photos/id/334/300/300","https://picsum.photos/id/338/300/300","https://picsum.photos/id/336/300/300","https://picsum.photos/id/334/300/300","https://picsum.photos/id/338/300/300","https://picsum.photos/id/336/300/300","https://picsum.photos/id/334/300/300","https://picsum.photos/id/338/300/300","https://picsum.photos/id/336/300/300"],
      activeImg:"",
      id:0,//展品id
      ocid:0,
      num:0,
      centerDialogVisible:false,
      textarea:"",//询盘内容
      list:{},//展品信息
      xgcp:{},//相关产品
      collect:1,//收藏状态  1未收藏 2已收藏
      meet:1,//邀约状态
      inquiry:false,//询盘
      inquiry2:false,//约见
      dialogFormVisible:false,//预约弹窗
      intention:false,//意向订单弹窗
      rules:{//约见校验
        date:[{ type: 'date', required: true, message: 'Select Date', trigger: 'change' }],
        connet:[{required: true, message: 'Input Your Message', trigger: 'blur'}],
      },
      intentionRules:{//意向校验
        amount:[{ validator: checkNumber, trigger: 'blur' }],
        address:[{required: true, message: 'Input Place', trigger: 'blur'}],
      },
      preAboutData:{//约见数据
        id:0,
        date:"",
        connet:"",
      },
      intentionData:{//意向数据
        id:0,
        amount:1,
        address:'',
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;//如果没有后面的-8.64e7就是不可以选择今天的
        }
      }
    }
  },
  mounted(){
    this.activeImg=this.imgList[0]
    // 截取字符串
    let id = this.$route.path.split('/')
    this.id=id[id.length-2]*1
    this.ocid=id[id.length-1]*1
    this.reqDetail(this.id)
    this.initCollect(this.id)
    // this.initCorpApp(this.ocid)
    // if (!this.isLogin) {
    //   this.$router.push('/home')
    // }
  },
  methods:{
    submitForm(formName) {//发送预约表单
      this.$refs[formName].validate(async(valid) => {
        if (valid) {//发送
          console.log(this.preAboutData);
          this.preAboutData.id=this.list.ocid
          const response = await reqCorpAppDo(this.preAboutData)
          if (response.code==0) {
            this.meet=response.is_coll
            this.success(this,'Succeed!')
            this.dialogFormVisible=false
          }else{
            this.err(this,'Timeout, please try...')
          }
        } else {//错误
          return false;
        }
      });
    },

    resetForm() {//预约表单重置
      this.$refs.preAboutData.resetFields();
      this.dialogFormVisible=false
      
    },

    async reqIntentiondata(){
      this.intention=true
    },
    intentionSubmitForm(formName) {//发送意向订单
      this.$refs[formName].validate(async(valid) => {
        if (valid) {//发送
          console.log(this.intentionData);
          this.intentionData.id=this.list.id
          const response = await reqListjsonOrderAdd(this.intentionData)
          if (response.code==2) {
            this.success(this,'Submit Successfully')
            this.intentionResetForm()
          }else{
            this.err(this,'Timeout, please try...')
          }
        } else {//错误
          return false;
        }
      });
    },

    intentionResetForm(){//意向表单重置
      this.$refs.intentionData.resetFields();
      this.intention=false
    },

    handleClose(){//询盘重置
      this.textarea=""
      this.centerDialogVisible=false
    },
    
    async reqAddCon(){// 询盘上传请求
      const response = await reqAddNote(this.list.id,this.textarea)
      if(response.code==0){
        this.err(this,'Exhibitor is offline, please try again later...')
      }else if (response.code==1) {
        this.centerDialogVisible=false
        this.textarea = ''
        this.success(this,'Send Successfully')
      }
    },
     
    async reqDetail(id){// 请求列表
      const response = await reqDetails(id)
      if(response.code==0){
          this.list=response.resilt[0]
          this.reqRelatedExh(response.resilt[0].fk_parentid)
      }else{
        this.$router.push("/")
      }
      
    },
    
    async reqRelatedExh(id){// 相关产品请求
      const response = await reqExhibitList(1,id)
      if(response.code==0){
        this.xgcp={list:response.resilt,name:"Related Products"}
      }
    },
    
    async initCollect(id){// 初始获取收藏状态
      const response = await reqProColl(id)
      if (response.code==0) this.collect=response.is_coll
      else this.collect = 1
    },

    async isCollect(id){// 修改收藏状态
      const response = await reqProCollDo(id)
      if (response.code==0) this.collect=response.is_coll
      else this.err(this,"Timeout, please try...")
    },
    
    xgxx(item){// 子组件调用替换产品数据
      this.reqDetail(item.id)
      this.initCollect(item.id)
    },
    
    async isCorpApp(ocid){// 修改约见状态
      if (!this.meet) {
        return
      }
      console.log(ocid);
      this.dialogFormVisible = true
    },

  },
  computed:{
    ...mapState({
      isLogin:state=>state.user.isLogin,
      user:state=>state.user.user,
    })
  }

}
</script>

<style scoped>
.p_zpxq{
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  padding-bottom: 30px;
  
}
.zpNav{
  position: absolute;
  left: 10px;
  top: 10px;
  font-size: 14px;
  font-weight: 600;
}
.zpNav span{
  cursor: pointer;
}
.zpNav span:hover{
  color: #008baf;
}
.zpxqHeader{
  background-image: url("https://cippe-1302098519.cos.ap-beijing.myqcloud.com/public/exhibit/zpxqbg.png");
  width: 100%;
  height: 120px;
  padding-top: 60px;
  box-sizing: border-box;
  background-size: 100% 100%;
}
.zsxqHeader::after{
  content: "";
  display: block;
  clear: both;
}
.zpxqImg{
  width: 20px;
}
.zpmz h2{
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 16px;
  padding-left: 10px;
  font-family: 'FjallaOne-Regular';
}

.zpxqContent{
  width: 100%;
  padding: 40px 20px;
}
.zpxqContent::after{
  content: "";
  clear: both;
  display: block;
}
.contentL{
  float: left;
  display: flex;
  margin-right: 20px;
}
.conLeft{
  width: 80px;
  height: 100%;
  max-height: 300px;
  overflow: hidden;
  position: relative;
  margin-right: 10px;
}

.conTop{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  cursor: pointer;
  z-index: 99;
}
.conBottom{
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  cursor: pointer;
  z-index: 99;
}
.conLeft>ul>li{
  cursor: pointer;
  margin-top: 10px;
}
.conLeft>ul>li:nth-child(1){
  margin-top: 20px;
}
.conLeft>ul>li>img{
  width: 100%;
  object-fit: cover;
}
.conImg{
  width: 300px;
  height: 300px;
}
.conImg>>>.el-image{
  width: 100%;
  height: 100%;
}
.conImg>>>.el-icon-circle-close{
  color: white;
}
.conImg>>>.el-image-viewer__canvas{
  padding: 20px;
}
.contentR{
  height: auto;
  padding-left: 320px;
}
.contentR >p{
  display: table-row;
  width: 100%;
}
.contentR .p1{
  display: table-cell;
  font-size: 14px;
  font-weight: 600;
  color: #008baf;
  line-height: 28px;
  width: 150px;
  text-align: end;
}
.contentR .p2{
  display: table-cell;
  line-height: 24px;
  font-size: 14px;
  width: calc(100% - 92px);
}
.contentR .chaolianjie{
  cursor: pointer;
}
.contentR .chaolianjie:hover{
  color: #008baf;
}
.detailBtn{
  margin-top: 20px;
  text-align: center;
  user-select: none;
  display: none;
}

.intentionBtn{
  width: 100%;
  height: 50px;
  outline: none;
  border: none;
  background-color: #008baf;
  color: white;
  font-size: 18px;
  cursor: pointer;
  margin-top: 30px;
  /* letter-spacing: .2em; */
  transition: all .5s;
  font-family: 'FjallaOne-Regular';
}
.intentionBtn:hover{
  background-color: #f08300;
}

.zplb{
  background-color: #eee;
}
.el-dialog__title{
  color: #333;
  font-size: 22px;
}
.textea{
  position: relative;
}
.p_zpxq >>> .el-textarea__inner{
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  height: 140px;
}
.dialog-footer>>>.el-button{
  width: 150px;
  height: 40px;
}

 /* 操作 start */
  .exchange{
    margin-bottom: 40px;
    width: 100%;
  }
  .exchange img{
    width: 20px;
  }
  .exchangeItem{
    width: calc(33.33% - 14px);
    padding: 10px 30px;
    background-color: #f7f7f7;
    display: inline-block;
    margin-left: 21px;
  }
  .exchangeItem:first-child{
    margin-left: 0px;
  }
  .exchangeTop{
    font-size: 22px;
    font-weight: 600;
    color: #000;
    padding-bottom: 20px;
    font-family: 'FjallaOne-Regular';
  }
  .exchangeTop img{
    float: right;
    width: 80px;
  }
  .exchangeTop::after{
    content: "";
    display: block;
    clear: both;
  }
  .exchangeBtn{
    width: 100%;
  }
  .exchangeBtn>button,
  .exchangeBtn1>button{
    width: 100%;
    line-height: 40px;
    font-size: 18px;
    font-weight: 600;
    border: 2px solid #008baf;
    outline: none;
    cursor: pointer;
    transition: all .5s;
    font-family: 'FjallaOne-Regular';
  }
  .exchangeBtn>button{
    color: #008baf;
    background-color: white;
  }
  .exchangeBtn1>button{
    color: white;
    background-color: #008baf;
  }
  .exchangeBtn>.btnACtive,
  .exchangeBtn>button:hover{
    color: white;
    background-color: #008baf;
  }
  .exchangeBtn1>.btnACtive,
  .exchangeBtn1>button:hover{
    color: white;
    background-color: #055d74;
    border-color: #055d74;
  }
    /* 操作 end */
</style>
<style scoped>
/* 预约弹窗 */
.yuyue>>> .el-dialog{
  background-color: white;
}
.yuyue >>> .el-dialog__body{
  padding: 20px 80px 20px 60px;
}
.yuyue >>>.el-form-item--mini.el-form-item,
.yuyue >>>.el-form-item--small.el-form-item{
  margin-bottom: 24px;
}
.yuyue >>>.el-form-item__label{
  line-height: 40px;
}
.yuyue >>>.el-input .el-input__inner{
  line-height: 40px;
  height: 40px;
}
.yuyue>>>.el-col-2{
  text-align: center;
  line-height: 40px;
}
.yuyue >>> .el-button{
  min-width: 150px;
}
</style>
<style scoped>
  /* 意向订单 */
  .intention_row{
    padding-left: 150px;
    font-size: 14px;
    line-height: 40px;
  }
  .intention_row .span1{
    margin-left: -150px;
    text-align: end;
    display: inline-block;
    width: 150px;
    padding-right: 12px;
  }
  .intention_row .span2{
    padding-left: 12px;
  }
  
</style>